import React, { Component } from 'react';
import { Password } from 'primereact/password';
import { Growl } from 'primereact/growl';
import { Message } from 'primereact/message';
import { Captcha } from "primereact/captcha";

import servicioObjetos from '../../servicio/ServicioObjetos';
import servicioHttp from '../../servicio/ServicioHttp';

class CambioContrasenaComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            usuario: {},
            errores: {},
            mostrarContrasenas: false,
            verificaCapchap: false,
            cadenaSolicitudCambiopwd: null
        };
        this.obtenerParametros();
    }

    obtenerParametros = () => {
        let { id } = this.props.match.params;
        if (servicioObjetos.esObjetoVacio(id)) {
            window.location = "/dif";
        }
        servicioHttp.consumirPostHttp("/usuario/contrasena/validar_vigencia.json",
            { cadenaSolicitudCambiopwd: id }).then(response => {
                setTimeout(function () {
                    if (!document.getElementById('g-recaptcha-response'))
                        window.location.reload();
                }, 500);
            }).catch(error => {
                window.location = "/dif";
            });
    }

    asignarValores = (event) => {
        servicioObjetos.asignarAtributosObjeto(event, this, false);
    };

    cambiarContrasena = () => {
        let { usuario, tokenCaptcha } = this.state;
        let validacion = this.validarForm(usuario);
        this.setState({ errores: validacion });

        if (servicioObjetos.esObjetoVacio(validacion)) {
            let { id } = this.props.match.params;
            usuario.token = tokenCaptcha;
            usuario.cadenaSolicitudCambiopwd = id;
            servicioHttp.consumirPostHttp("/usuario/contrasena/actualizarContrasena.json", usuario)
                .then((response) => {
                    this.growl.show({
                        severity: 'success',
                        detail: response.data.mensaje, life: 20000

                    });
                    this.setState({ usuario: {}, errores: {} });
                    setTimeout(function () {
                        window.location = "/dif";
                    }, 3500);
                }).catch((e) => {
                    //this.growl.show({ severity: 'error', detail: e.response.mensaje, life: 20000 });
                    window.location = "/dif";
                });
        }

    }

    respuestaCaptcha = (response) => {
        this.setState({
            tokenCaptcha: response.response
        });
    }

    expireCaptcha = () => {
        this.setState({
            tokenCaptcha: null
        });
        this.captcha.reset();
    }

    validarForm = (usuario) => {
        const errores = {};
        let { tokenCaptcha } = this.state;

        if (servicioObjetos.esObjetoVacio(tokenCaptcha))
            errores.captcha = 'Debe resolver el captcha';
        if (!usuario.contrasena)
            errores.contrasena = "La contraseña es requerida";
        if (!usuario.confirmaContrasena)
            errores.confirmaContrasena = "La confirmación de la contraseña es requerida";
        if (usuario.contrasena !== usuario.confirmaContrasena)
            errores.confirmaContrasena = "Las contraseñas no coinciden";
        if (!document.getElementById('g-recaptcha-response')) {
            errores.captcha = 'Al parecer el captcha no se ha cargado con éxito, es necesario que oprima la tecla F5 o recargue la página';
        }
        return errores;
    };

    render() {

        let { usuario, errores } = this.state;

        return (
            <div>
                <Growl ref={(el) => this.growl = el} />
                <div class="layout-wrapper layout-static layout-static-sidebar-inactive p-ripple-disabled">
                    <div class="layout-topbar clearfix">
                        <div class="topbar-left p-ml-3 p-d-flex">
                            <span style={{ justifyContent: 'left', alignItems: 'center', fontFamily: 'tuna-medium', fontSize: '2em' }}>
                                SNDIF
                            </span>
                        </div>
                    </div>
                    <div class="layout-main">
                        <div class="p-grid p-fluid">
                            <div class="p-col-12 p-lg-2"></div>
                            <div class="p-col-12 p-lg-8" style={{ paddingTop: '80px' }}>
                                <div class="card">
                                    <h1 style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', fontWeight: 'bold' }}>Recuperar Contraseña</h1>
                                    <div class="p-grid p-fluid">

                                        <div class="p-col-12 p-lg-12">
                                            <h2 style={{ marginTop: '1px', fontSize: '1.3em' }}>
                                                Ingresa la información que se requiere
                                            </h2>
                                            <h4 style={{ marginTop: '3px' }}>
                                                Los campos con * son obligatorios
                                            </h4>
                                        </div>
                                        <div class="p-col-12 p-md-12" >
                                            <Password placeholder="* Contraseña" id="contrasena" className={errores.contrasena ? 'p-inputtext p-component' : 'p-inputtext p-component'}
                                                name="usuario.contrasena" value={usuario.contrasena || ""} onChange={this.asignarValores} type="password"
                                                promptLabel="Ingresa la Contraseña" weakLabel="Contraseña débil" mediumLabel="Contraseña insegura" strongLabel="Contraseña segura" />
                                            {errores.contrasena ? <div> <Message severity="error" text={errores.contrasena} /> </div> : null}
                                        </div>
                                        <div class="p-col-12 p-md-12">
                                            <Password placeholder="* Confirma la Contraseña" id="usuario.confirmaContrasena" className={errores.usuario ? 'p-inputtext p-component' : 'p-inputtext p-component'}
                                                name="usuario.confirmaContrasena" value={usuario.confirmaContrasena || ""} onChange={this.asignarValores} type="password"
                                                promptLabel="Confirma la Contraseña" weakLabel="Contraseña débil" mediumLabel="Contraseña insegura" strongLabel="Contraseña segura" />
                                            {errores.confirmaContrasena ? <div> <Message severity="error" text={errores.confirmaContrasena} /> </div> : null}
                                        </div>
                                        <div class="p-col-12 p-lg-12" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Captcha ref={(r) => this.captcha = r} theme="dark" siteKey="6LfFYG0UAAAAAJsylLTvKIbfdDpgiWPUIP0acdEB" onResponse={this.respuestaCaptcha} onExpire={this.expireCaptcha} language="es"></Captcha>
                                            {errores.captcha ? <div><Message severity="error" text={errores.captcha} /> </div> : null}
                                        </div>
                                        <div class="p-col-12 p-lg-9" />
                                        <div class="p-col-12 p-lg-3">
                                            <button class="p-button p-component p-button-text-icon-left" onClick={this.cambiarContrasena}>
                                                <span class="pi pi-refresh p-c p-button-icon-left" />
                                                <span class="p-button-text p-c">Recuperar contraseña</span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CambioContrasenaComponent;